export default __webpack_public_path__ + "media/flags/my-ac920fd6.svg";